import { render, staticRenderFns } from "./ProfileMenu.vue?vue&type=template&id=154fba3e&scoped=true"
import script from "./ProfileMenu.vue?vue&type=script&lang=ts"
export * from "./ProfileMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154fba3e",
  null
  
)

export default component.exports